import { useMemo } from "react";
import { useSessionContext } from "@/components/AuthModule/SessionContext";
import { moreTravelSavingsBanners, matchEligibility } from "@/utils/banners";

export const useMoreTravelSavingsBanners = () => {
  const { sessionInfo } = useSessionContext();

  return useMemo(() => {
    const banners = moreTravelSavingsBanners;
    return banners.filter((banner) => {
      return matchEligibility(
        sessionInfo?.userDetails,
        banner.eligibilityPayloadMapping
      );
    });
  }, [sessionInfo?.userDetails]);
};
